// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:46:14+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            2aa24ab3ce92f6f84a989b548ad3cb87
//    Signature:      eyJpdiI6InZNTFhSMkxHMjJ2UmIxR0dYT0hvNGc9PSIsInZhbHVlIjoieEtUaEJsUGVMU3YyZ3paMEh2TDNCYm9RdnljNm12VWwwOUVlRVc2eDdvQjRvTmdjZUcwb29lNGtaUVdcL2hkYzR3Z0h4alwvSDlmMENxYURQRnpRdUpuRFZFYXFNTHJUTzZFWnJCdmNwekVpMHQ2YkFlcERcL2kzRGE2Vk9hc1U1Q1lia2h5RjB3WkFXV1p3SlhkOGlCN2NBYWltMGU5UEZVZXZaa25PdDZETVgzY2J0V3lUclpiclFqVUpZM0FzTDBcLytpMlZZV3BSXC9zdnNYQ1V0SjIxUGhrUXlkTU9USHlGSUdQRGcwRklrVDRJNzVkR29INzAwWVlrNEVtOWp6RFwvVjM2NUVZaEMzQmFZWWNIVllIZjNLaEVXSWZ6WmRFZTducUdhcHFwVHpWRDY1Y29kWG5aWGl6OVwvUmRnMWkxVmNjdEdiaVF1QzRvVkpIVnJKbDA1cnd6QjlsNjhjTmo1VjdUVDJEQ25kc3BqdDVUS1g5MFVYeVdyRCtKUEc0Z3dxbmFxNm1DM0hVUFFVdFBya00xZ3cyYlE9PSIsIm1hYyI6IjA1OGQxYjMxNDNkZTYzYjJiM2I5ZmM3NmM4M2ZmM2JiMzNlMzY5NDRlZDE5ZjBmYjFmNTUxNDE3NmViZmI0MjEifQ==
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
